// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"889be097","498":"7631b972","703":"3523966b"}[chunkId] + ".chunk.js";
};